@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Virginia</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      <div
        class="axis-form-group _mt-medium"
        [ngClass]="{
          'has-axis-required':
            reactiveForm.get(controls[0].formControlName)?.value === null ||
            reactiveForm.get(controls[0].formControlName)?.value === '',
          'has-axis-error':
            reactiveForm.get(controls[0].formControlName)?.touched &&
            reactiveForm.get(controls[0].formControlName)?.invalid,
        }"
      >
        @if (controls?.length >= 1) {
          <label>{{ textValues?.Default_Label }}</label>
          <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
            @for (control of controls[0].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[0].formControlName)?.touched) {
            @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
              <span class="axis-error-block">Please select an option.</span>
            }
          }
        }
      </div>

      <div class="axis-grid">
        @if ((baseRules?.["SplitMinLimits_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[5].label }}</label>
              <div id="splitminlimits_50k_100k-pdffield-virginia">
                {{ controls[5].data[0].name }}
              </div>
            </div>
          </div>
        }
        @if ((baseRules?.["UMPDMinLimit_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[6].label }}</label>
              <div id="umpdminlimit_25k-pdffield-virginia">
                {{ controls[6].data[0].name }}
              </div>
            </div>
          </div>
        }
        @if ((baseRules?.["CombinedSingleMinLimit_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[7].label }}</label>
              <div id="combinedsingleminlimit_125k-pdffield-virginia">
                {{ controls[7].data[0].name }}
              </div>
            </div>
          </div>
        }
        @if ((baseRules?.["LiabilityLimit_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[12].label }}</label>
              <div id="liabilitylimit_Limit_equal_to_the_limit_of_my_Bodily_Injury_Liability_Coverage-pdffield-virginia">
                {{ controls[12].data[0].name }}
              </div>
            </div>
          </div>
        }
      </div>

      <div class="axis-grid">
        @for (control of controls | slice: 1; track $index) {
          @if (
            baseRules[control.baseRuleKey]?.includes("show") &&
            control?.formControlName !== "Alternative_Coverage_DropDown"
          ) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                  >{{ control.label }}
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                    >*</span
                  >
                </label>
                <axis-dropdown
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span class="axis-error-block">Please select an option.</span>
                  }
                }
              </div>
            </div>
          }
        }
      </div>
      <ul>
        <li>{{ textValues?.Bullet_Text[0] }}</li>
        <li>{{ textValues?.Bullet_Text[1] }}</li>
      </ul>
      <!-- Alternative Dropdown -->
      <div class="axis-grid _mt-large">
        @for (control of controls | slice: 9; track $index) {
          @if (baseRules[control.baseRuleKey]?.includes("form")) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                  >{{ control.label }}
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                    >*</span
                  >
                </label>
                <axis-dropdown
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span class="axis-error-block">Please select an option.</span>
                  }
                }
              </div>
            </div>
          }
        }
      </div>
    </form>
    <p>{{ textValues?.description }}</p>
  }
}
@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Virginia</h2>
  @if (baseRules?.Reject_LevelOne_Radio) {
    <div class="axis-form-group">
      <label
        class="axis-control-label"
      >
        {{ textValues?.Reject_Text }}
      </label>
      <div>{{ baseRules?.Reject_LevelOne_Radio }}</div>
    </div>
  }
  <div class="axis-grid">
    @if (baseRules.SplitMinLimits_DropDown && baseRules.UMPDMinLimit_DropDown) {
      <div class="axis-col-sm-6 axis-col-lg-6">
        <div class="axis-form-group">
          <label
            class="axis-control-label"
            >{{ controls[4].label }}
          </label>
          <div>{{ controls[4].data[0].name }}</div>
        </div>
      </div>
      <div class="axis-col-sm-6 axis-col-lg-6">
        <div class="axis-form-group">
          <label
            class="axis-control-label"
            >{{ controls[5].label }}
          </label>
          <div>{{ controls[5].data[0].name }}</div>
        </div>
      </div>
    }

    @if (baseRules.CombinedSingleMinLimit_DropDown) {
      <div class="axis-col-sm-6 axis-col-lg-6">
        <div class="axis-form-group">
          <label
            class="axis-control-label"
            >{{ controls[11].label }}
          </label>
          <div id="combinedsingleminlimit_125k-pdffield-virginia">{{ controls[7].data[0].name }}</div>
        </div>
      </div>
    }
  </div>
}
